module.exports = "/work-site/img/fix_situation.3ae38172.png";